import React, { ReactNode } from 'react';

import icon_acc_close from '../assets/img/common/icon_acc_close.svg';
import icon_acc_open from '../assets/img/common/icon_acc_open.svg';

type AccordionProps = {
    title: string;
    open: boolean;
    children: ReactNode;
}
const Accordion:React.FC<AccordionProps> = (props) => {

    const { title, open = true, children } = props;

    const [toggle, setToggle] = React.useState<boolean>(open);

    const handleToggle:React.ReactEventHandler<HTMLDetailsElement> = (node) => {
        setToggle(node.currentTarget.open);
    }

    return (
        <details className="c-search-detail" open={toggle} aria-expanded={toggle} onToggle={handleToggle}>
        <summary className="c-search-detail__head">
            {title}{(toggle)?(<span className="c-icon"><svg width={18} height={10} aria-label="閉じる"><use href={`${icon_acc_close}#iconAccClose`} /></svg></span>):(<span className="c-icon"><svg width={18} height={10} aria-label="開く"><use href={`${icon_acc_open}#iconAccOpen`} /></svg></span>)}
        </summary>
        <div className="c-search-detail__body c-form--separate">
            {children}
        </div>
        </details>
    )
}
export default Accordion;